// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"UiInputElWrapper_wrapper__QXfCx"};